module.exports = __webpack_public_path__ + "img/skull-cow.292bbe96.svg";